import React, { useState } from "react";
import divorceCostBoxStyle from "./divorceCostBoxStyle";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DialogModal from "../../../DialogModal/DialogModal";
import CostOverviewContainer from "../CostOverviewContainer";
import { useLocation, useNavigate } from "react-router";
import { calculateFees, calculateValueInDispute } from "../../../../services/costCalculation";
import { FormProvider } from "../../../../provider/Form/FormProvider";
import DivorceCostCalculatorForm from "./DivorceCostCalculatorForm";
import { Typography } from "@mui/material";
import { FormDataTypes } from "../../../../types/FormDataTypes";
import { DivorceFees, ValueInDispute } from "../../../../types/CostCalculatorDivorce";
import { gaEvent } from "../../../../services/googleAnalyticsService";

const DivorceCostCalculator = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [valueInDispute, setValueInDispute] = useState<ValueInDispute | null>(null);
  const [fees, setFees] = useState<DivorceFees | null>(null);

  const initialValues = {
    netIncomePetitioner: "",
    netIncomePartner: "",
    numberPensions: "",
    numberPensionsPartner: "",
    pensionsExcluded: false,
  };

  const handleSubmit = ({ values }: { values: FormDataTypes["values"] }) => {
    const vid = calculateValueInDispute(values);
    const calculatedFees = calculateFees(vid.total);
    setValueInDispute(vid);
    setFees(calculatedFees);
  };

  const toRecalc = () => {
    gaEvent({
      category: "Cost Calculator",
      action: "Re-calculate",
    });
    setValueInDispute(null);
    setFees(null);
  };

  const costDetailModalClose = () => {
    navigate(-1);
  };

  if (valueInDispute && fees) {
    return (
      <Grid container spacing={1} sx={{
        alignItems: "center"
      }}>
        <Grid size={12}>
          <Grid container sx={{
            justifyContent: "space-between"
          }}>
            <Grid sx={[divorceCostBoxStyle.costEstimateLabel, divorceCostBoxStyle.primary]}>
              Kostenschätzung
            </Grid>
            <Grid sx={[divorceCostBoxStyle.costEstimateValue, divorceCostBoxStyle.primary]}>
              {fees.total.toLocaleString("de-DE", { style: "currency", currency: "EUR" })}*
            </Grid>
          </Grid>
        </Grid>
        <Grid size={12}>
          <Button
            sx={divorceCostBoxStyle.costButton}
            variant="contained"
            onClick={() => navigate(location.pathname, { state: { costLayerModalOpen: true } })}
            fullWidth
          >
            Kosten im Detail
          </Button>
        </Grid>
        <Grid size={12}>
          <Button onClick={toRecalc} sx={divorceCostBoxStyle.costButton} variant="contained" fullWidth>
            Neu berechnen
          </Button>
        </Grid>
        <Grid size={12}>
          <Typography sx={divorceCostBoxStyle.costDisclaimerText}>
            *Dies ist eine Vorschusskosten-Rechnung. Die letztendlich anfallenden Kosten werden vom Gericht festgesetzt.
          </Typography>
          <hr />
        </Grid>
        <Grid sx={divorceCostBoxStyle.hintBox} size={12}>
          <Grid sx={divorceCostBoxStyle.paymentHint} size={12}>
            Fragen zur Finanzierung?
          </Grid>
          <Grid size={12}>
            Melden Sie sich dazu gerne direkt bei uns und wir finden gemeinsam das für Sie passende Modell!
          </Grid>
        </Grid>
        <DialogModal open={!!(location.state && location.state.costLayerModalOpen)} onClose={costDetailModalClose} title={"Kostenschätzung"}>
          <CostOverviewContainer fees={fees} valueInDispute={valueInDispute} />
        </DialogModal>
      </Grid>
    );
  }

  return (
    <FormProvider initialValues={initialValues} submitAction={handleSubmit}>
      <DivorceCostCalculatorForm />
    </FormProvider>
  );
};

export default DivorceCostCalculator;
